import useStyles from "../BulkEmployeeCard/styles";
import { useState, useRef } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import Button from "../Button";
import { Grid, Radio, FormControlLabel, FormControl, FormLabel } from "@mui/material";
import { toast } from "react-toastify";

const BulkQuestionImport = ({
  fileType,
  onFileTypeChange,
  createClick,
  isLoading,
  sampleCsvUrl,
  sampleXlsxUrl
}) => {
  const classes = useStyles();
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const isCsv = fileType === "csv";
  const accept = isCsv ? ".csv" : ".xlsx";
  const sampleUrl = isCsv ? sampleCsvUrl : sampleXlsxUrl;
  const sampleLabel = isCsv ? "Download a sample csv file" : "Download a sample xlsx file";

  const handleFileTypeChange = (newType) => {
    setSelectedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    onFileTypeChange(newType);
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    setSelectedFile(file || null);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleCreate = () => {
    if (selectedFile) {
      createClick(selectedFile);
    } else {
      toast.error(`Please select a ${isCsv ? "CSV" : "Excel"} file`);
    }
  };

  return (
    <>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <FormControl component="fieldset" sx={{ display: "block", marginBottom: 2 }}>
          <FormLabel component="legend" sx={{ marginBottom: 1, fontWeight: 500 }}>
            File type
          </FormLabel>
          <div style={{ display: "flex", flexDirection: "row", gap: 24, alignItems: "center" }}>
            <FormControlLabel
              value="csv"
              control={
                <Radio
                  checked={fileType === "csv"}
                  onChange={() => handleFileTypeChange("csv")}
                  value="csv"
                  name="batch-file-type"
                />
              }
              label="CSV"
            />
            <FormControlLabel
              value="xlsx"
              control={
                <Radio
                  checked={fileType === "xlsx"}
                  onChange={() => handleFileTypeChange("xlsx")}
                  value="xlsx"
                  name="batch-file-type"
                />
              }
              label="Excel"
            />
          </div>
        </FormControl>
      </Grid>
      <div className={classes.pickercontainer}>
        <input
          ref={fileInputRef}
          onChange={handleFileChange}
          type="file"
          className={classes.picker}
          accept={accept}
        />
        <div className={classes.uploadflex}>
          <div>
            <h2 className={classes.uploadtitle}>Upload {isCsv ? "CSV" : "Excel"}</h2>
            <a
              className={classes.uploadsubtitle}
              download={isCsv ? "question.csv" : "questions.xlsx"}
              href={sampleUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {sampleLabel}
            </a>
          </div>
        </div>
        {selectedFile && (
          <div className={classes.selectedfile}>
            <p>
              Selected file: <strong>{selectedFile.name}</strong>
            </p>
            <Icon
              icon="line-md:minus-circle"
              onClick={handleRemoveFile}
              width="25"
              height="25"
              style={{ color: "#D42620" }}
            />
          </div>
        )}
      </div>
      <Grid container spacing={1}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <div className={classes.btn}>
            <Button
              variant="primary"
              buttonName="Import Questions"
              buttonSize="full"
              color="btndefault"
              onClick={handleCreate}
              isLoading={isLoading}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default BulkQuestionImport;
